import * as React from 'react'

const SvgXDouble2Icon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.04378 18.1392L5.70957 13.7154L2.33177 18.1392H0.813622C0.481522 18.1392 0.294064 17.7579 0.496876 17.495L4.55458 12.2335L0.712505 7.233C0.510372 6.96992 0.697926 6.58929 1.02969 6.58929H2.54969L5.73136 10.7516L8.89124 6.58929H10.3652C10.6974 6.58929 10.8848 6.97082 10.6818 7.23377L6.82097 12.2335L10.9164 17.4935C11.1209 17.7562 10.9337 18.1392 10.6008 18.1392H9.04378Z"
      fill="white"
    />
    <path
      d="M19.5 9.74919C19.7761 9.74919 20 9.97304 20 10.2492V10.5131C20 10.7893 19.7761 11.0131 19.5 11.0131H13.2214C12.9452 11.0131 12.7214 10.7893 12.7214 10.5131V10.486C12.7214 10.1978 12.8458 9.92358 13.0626 9.7337L16.753 6.50212C17.2614 6.05175 17.6029 5.68854 17.7772 5.41251C17.9661 5.12194 18.0605 4.83138 18.0605 4.54081C18.0605 4.13402 17.8789 3.80714 17.5157 3.56016C17.1525 3.29865 16.6077 3.16789 15.8813 3.16789C15.3437 3.16789 14.8643 3.25506 14.443 3.4294C14.1167 3.55314 13.8341 3.72479 13.5949 3.94435C13.4774 4.05225 13.2981 4.07192 13.1721 3.97415L12.5685 3.50607C12.4367 3.40384 12.4127 3.21261 12.5272 3.09131C13.3018 2.27067 14.4562 1.86035 15.9902 1.86035C17.138 1.86035 18.0242 2.10007 18.6489 2.5795C19.2736 3.05893 19.5859 3.67638 19.5859 4.43185C19.5859 4.89675 19.4697 5.3326 19.2373 5.73939C19.0048 6.14618 18.5617 6.64014 17.9079 7.22127L15.0314 9.74919H19.5Z"
      fill="white"
    />
  </svg>
)

export default SvgXDouble2Icon
